"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var ProductPage = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(ProductPage, _window$AbstractView);

    var _super = _createSuper(ProductPage);

    function ProductPage(id, options) {
      var _this;

      _classCallCheck(this, ProductPage);

      $.extend(true, options, {
        autoInstance: [{
          selector: ".items-carousel",
          ModuleClass: RelatedProductsCarousel,
          observeChild: null,
          // takes the domElement of the view
          subtree: true
          /*options: {
            watchResize: true,
            watchResizeTimeout: 1000
          }*/

        }]
      });
      _this = _super.call(this, id, options);
      _this.$backBtn = _this.$domElement.find(".product-page page__back-btn");
      return _this;
    }

    _createClass(ProductPage, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        _get(_getPrototypeOf(ProductPage.prototype), "addModules", this).call(this, [new window.ProductContent(this.id + "_product-content", {
          $domElement: this.$domElement.find(".product-content"),
          quickView: this.quickView
        })]);

        this.$domElement.find(".items-carousel").each(function (i, el) {
          console.log('el', el);

          _get(_getPrototypeOf(ProductPage.prototype), "addModules", _this2).call(_this2, [new window.RelatedProductsCarousel(_this2.id + "_related-products-carousel-" + (i + 1).toString(), {
            $domElement: $(el)
          })]);
        });
        this.$backBtn.on("click", function (event) {});

        _get(_getPrototypeOf(ProductPage.prototype), "init", this).call(this);

        loadProductRecommendationsIntoSection();
        setTimeout(function () {
          if (!$('.feedaty_widget[data-type="carouselproduct"]').text().trim().length) {
            FeedatyWidget.init();
          }
        }, 1000);
      }
    }]);

    return ProductPage;
  }(window.AbstractView);

  window.ProductPage = ProductPage;
})(window);
